<template>
  <div>
    <van-nav-bar title="我要吐槽" :border="false"  @click-right="addTopic" left-arrow  @click-left="goBack" >
      <span slot="right" style="font-size: 14px;color: #43b292"> 发表帖子 </span>
    </van-nav-bar>

    <van-tabbar v-model="listType" :fixed="false" :border="false" @change="tabChange" style="margin: 5px auto"  >
      <van-tabbar-item  name="all" >
        <span slot="icon" class="wcc-icon wcc-icon-all"
              style="font-size: 26px;"
              :style="{color:listType=='all'?'#43b292':'#8093af','font-family':listType=='all'?'FontAwesomeB':'FontAwesome'}"></span>
        <span style="font-size: 14px" :style="{color:listType=='all'?'#eeeeee':'#8093af'}">全部</span>
      </van-tabbar-item>
      <van-tabbar-item  name="mine" >

        <span slot="icon" class="wcc-icon wcc-icon-mine"
              style="font-size: 26px"
              :style="{color:listType=='mine'?'#43b292':'#8093af','font-family':listType=='mine'?'FontAwesomeB':'FontAwesome'}"></span>
        <span style="font-size: 14px" :style="{color:listType=='mine'?'#eeeeee':'#8093af'}">我的</span>
      </van-tabbar-item>
    </van-tabbar>

    <van-divider :style="{  borderColor: '#2a405c',marginBottom:'0px'}" ></van-divider>

    <van-pull-refresh v-model="refreshing" @refresh="refresh">
      <van-list
              v-model="loading"
              :finished="finished"  :offset="10"
              finished-text=" "
              @load="loadMore"
      >
        <van-cell
                v-for="item in topics"
                :key="item.tid"
                is-link  :to="'Topic' + item.tid"
        >
          <div slot="title" class="van-multi-ellipsis--l2" style="font-size: 14px;color: #eeeeee;font-weight: normal">{{item.title}} </div>
          <div slot="label" style="font-size: 12px">
            <Nick :uid="item.uid" /> 发表于 {{moment(item.ctime).fromNow()}}

            <span class="wcc-icon wcc-icon-post"  style="float: right;line-height: 18px"  > {{item.postCount}}</span>
            <span class="wcc-icon wcc-icon-agree"  style="float: right;line-height: 18px;margin-right: 15px; " > {{item.agreeCount}}</span>

          </div>
          <div slot="right-icon" style="font-size: 12px;color: #8197b3">
<!--            <span class="wcc-icon wcc-icon-agree"  style="margin-right: 15px; " > {{item.agreeCount}}</span>-->
<!--            <span class="wcc-icon wcc-icon-post"    > {{item.agreeCount}}</span>-->
          </div>
        </van-cell>
      </van-list>

    </van-pull-refresh>

    <van-popup v-model="showLogin" position="bottom"  round :close-on-click-overlay="false"
               safe-area-inset-bottom>

      <van-cell-group style="margin-bottom: 50px">
        <van-cell title="手机号登录"></van-cell>
        <van-field
                v-model="uid"
                center
                clearable
                label="手机号"
                placeholder="请输入手机号"
        >
          <van-button slot="button" size="small" type="primary" v-if="uid" @click="login">登录</van-button>
        </van-field>
      </van-cell-group>
    </van-popup>
  </div>
</template>

<script>
// @ is an alias to /src
import Nick from "../components/nick"

export default {
  name: 'home',
  components: {
    Nick
  },
  data:function(){
    return {
      loading:false,
      refreshing:false,
      finished: false,
      topics:[],
      total:0,
      start:0,
      len:10,
      showLogin:false,
      uid:'',
      listType:'all',//all mine
    }
  },
  methods:{
    goBack:function(){
      if(window.JSInterface) {
        window.JSInterface.callMethod('close', null)
      }
    },
    tabChange:function(){
      var app = this;
      if(app.listType=='mine' && !app.checkLogin()){
        app.listType='all'
        return;
      }
      else{
        app.refresh();
      }
    },
    refresh:function(){
      console.log("refresh")
        var app = this;
        app.start = 0;
        app.len =10;
        app.loading = true;
        app.loadMore()
    },
    loadMore:function(){
      var app=this;

      console.log("loadMore",app.loading,app.refreshing,app.start);


      app.axios.post("/listTopic",{
        start:app.start,
        len:app.len,
        byUid: app.listType=='mine'
      })
              .then(function(res){
                if(res.data.errcode=='suc') {
                  // console.log("old",app.start,app.len,app.total,app.topics.length);
                  if(app.start==0){
                    // console.log("替换")
                    app.topics.splice(0);
                    app.topics = [].concat(app.topics,res.data.data.list);
                  }
                  else{
                    // console.log("凭借")
                    app.topics = [].concat(app.topics,res.data.data.list);
                  }

                  app.total = res.data.data.total;
                  app.len = res.data.data.len;
                  app.start = res.data.data.start + app.len;

                  // console.log("loaded ",'next-start',app.start ,'len', app.len,'total',app.total,'length',app.topics.length)
                  if(app.start < app.total){
                    app.finished = false
                  }
                  else{
                    app.finished = true;
                  }
                }
                else{
                  console.log("loadMore",res.data.errcode)
                  app.topics.splice(0);
                  app.total = 0;
                  app.len = 10;
                  app.start = 0;
                  app.finished = true;

                }
                app.loading = false;
                app.refreshing = false;
              })
              .catch(function(){
                app.finished = true;
                app.loading = false;
                app.refreshing = false;
              })
    },
    checkLogin:function(){
      var app = this;
      console.log("检查登录");
      if(!app.$cookie.get("session")){
        if(window.JSInterface) {
          window.JSInterface.callMethod('login', null);
        }
        return false;
      }
      return true;
    },
    addTopic:function(){
      var app = this;
      if(!app.checkLogin()){
        return;
      }
      app.$router.push({name:"AddTopic"})
    },
    login:function(){
      var app = this;
      app.axios.post("/login",{
        uid:app.uid
      }).then(function(res){
        if(res.data.errcode=="suc"){
          app.showLogin = false;
          app.loadMore();
        }
      })
    }
  },
  mounted:function(){

  }
}
</script>
<style>
  .van-list__finished-text{
    font-size: 12px;
  }
</style>
